import { apiClient } from "@/api";

export const DriverApi = {
  /**
   * Получение списка водителей
   * @param {Object} params - Параметры запроса
   * @returns {Promise<Array>}
   */
  async fetchDrivers(params = {}) {
    return apiClient.get("/drivers", { params });
  },

  /**
   * Создание нового водителя
   * @param {Object} data - Данные водителя
   * @returns {Promise<Object>}
   */
  async createDriver(data = {}) {
    return apiClient.post("/drivers", data);
  },

  /**
   * Получение данных водителя по ID
   * @param {Number} id - ID водителя
   * @returns {Promise<Object>}
   */
  async fetchDriver(id) {
    return apiClient.get(`/drivers/${id}`);
  },

  /**
   * Обновление существующего водителя
   * @param {Number} id - ID водителя
   * @param {Object} data - Данные водителя
   * @returns {Promise<Object>}
   */
  async updateDriver(id, data = {}) {
    return apiClient.put(`/drivers/${id}`, data);
  },

  /**
   * Удаление водителя
   * @param {Number} id - ID водителя
   * @returns {Promise<Object>}
   */
  async deleteDriver(id) {
    return apiClient.delete(`/drivers/${id}`);
  },
};
